import { v4 as uuid } from 'uuid';
import { SHOW_CONTENT_NUMBERS } from 'admin/utils/contants';
import { Images } from 'assets/images';
import { SampleImage, SampleSpan, SelectWrapper } from 'admin/layout/styled';
import {
  SelectOptionWrapper,
  ComponentTopBlock,
} from 'admin/components/Packages/styled';
import {
  DeleteAllButton,
  DeleteAndSearchBlock,
  SearchInput,
  SearchWrapper,
  Select,
  AboutContentBlock,
  AddButton,
  ShowQuantityWrapper,
  TitleAndAddButton,
  TitleOfPage,
} from 'admin/components/Packages/styled';

export const PackagesTopBlock = ({
  selected,
  setSelected,
  _data,
  setData,
  selectedItems,
}) => {
  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  const deleteAll = () => {
    if (selectedItems) {
      setData((prevState) =>
        prevState.filter((element) =>
          selectedItems.every((item) => item.id !== element.id),
        ),
      );
    }
  };

  return (
    <ComponentTopBlock>
      <TitleAndAddButton>
        <TitleOfPage>Packages</TitleOfPage>
        <AddButton>+ Add</AddButton>
      </TitleAndAddButton>

      <AboutContentBlock>
        <ShowQuantityWrapper>
          <SampleSpan>Show</SampleSpan>
          <SelectWrapper>
            <Select value={selected} showContentNumbers onChange={handleChange}>
              {SHOW_CONTENT_NUMBERS.map((element) => (
                <option value={element.value} key={uuid()}>
                  {element.value}
                </option>
              ))}
              <option value={_data.length} key={uuid()}>
                All
              </option>
            </Select>
          </SelectWrapper>

          <SampleSpan>entries</SampleSpan>
        </ShowQuantityWrapper>

        <DeleteAndSearchBlock>
          <SelectOptionWrapper>
            <Select>
              <option>asd</option>
              <option>asd</option>
              <option>asd</option>
              <option>asd</option>
              <option>asd</option>
              <option>asd</option>
              <option>asd</option>
              <option>asd</option>
            </Select>
          </SelectOptionWrapper>

          <DeleteAllButton onClick={deleteAll}>Delete All</DeleteAllButton>
          <SearchWrapper>
            <SearchInput type="text" />
            <SampleImage src={Images.searchIcon} />
          </SearchWrapper>
        </DeleteAndSearchBlock>
      </AboutContentBlock>
    </ComponentTopBlock>
  );
};
